<template>
  <div class="col-xs-12 area_padding" style="height: calc(100vh - 60px);">
    <div class="table-responsive mt50">
      <table class="table table_base table_upload">
        <thead>
          <tr>
            <th></th>
            <th>{{ $t('update.table.hardware') }}</th>
            <th>{{ $t('update.table.software') }}</th>
            <th>{{ $t('update.table.latestSoftware') }}</th>
            <th>{{ $t('update.table.updateInfo') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in fwVerInfoList" :key="item.Type">
            <td>
              <img :src="funcShowImage(item)" alt="parts img">
              <p class="hardware_name"> {{ $t('update.table.device.'+(item.Device).toLowerCase()) }}
                <span>{{ item.PartName }}</span>
              </p>
            </td>
            <td>{{ item.HwVer }}</td>
            <td>{{ item.FwVer }}</td>
            <td>{{ item.LatestFW }}</td>
            <td>
              <span v-if="!funcCheckFWVer(item.HasData,item.PartType, item.FwVer, item.LatestFW) ">{{ $t('update.table.lastestVersion') }}</span>
              <span v-else>
                <button
                  :id="'btnUpdate' + item.Device "
                  class="btn btn_normalBtn"
                  data-toggle="modal"
                  data-target="#upload_model"
                  @click="funcGetPartFWData(item)">{{ $t('update.table.updateBtn') }}</button>
                <p>{{ $t('update.table.updateContent') }}</p>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <UploadModal
      :objUpdatedVer="objUpdatedVer"
      :objUpdatedMsg="objUpdatedMsg"
      :funcShowImage="funcShowImage"
      ref="refWindowEvent"
      @hide="funcCloseModal"/>
    <uiv-modal v-model="modalOpenDisconnect" class="v-modal-style" :backdrop="false" :footer="!hideFooter">
      <h4 slot="header" class="modal-title">{{ modal.data.title }}</h4>
      <p slot="default">{{ modal.data.content }}</p>
      <template slot="footer">
        <button
          id="btnOK"
          type="button"
          class="btn btn-default mb20"
          @click="funcOkBtnDialog">{{ modal.btn.ok }}</button>
      </template>
    </uiv-modal>
    <Loading :loadingText="$t('loading.loadingText')" v-if="loading"/>
  </div>
</template>
<script>
import UploadModal from './components/Modal';
import { funcEncryptData, funcDecryptData } from '@/utils/crypt';
import { websocketAPI, updateAPI } from '@/mixins/websocket-api';
import * as connectBikeAPI from '@/api/connect-bike';
import { mapGetters } from 'vuex';
import Loading from '@/components/Loading.vue';
import { allowPartNo, funcOriginalPartNo, checkIsGorillaPN } from '@/utils/allowPartNo';

export default {
  name: 'Update',
  mixins: [websocketAPI, updateAPI],
  data () {
    return {
      testSystemInfoList: [],
      modalOpenDisconnect: false,
      boolUpdateStart: false,
      modal: {
        data: {
          title: this.$t('bikeOverview.modalTitle'),
          content: ''
        },
        btn: {
          ok: this.$t('bikeOverview.modalBtnOk')
        }
      },
      boolDisconnect: false,
      arrFwList: [],
      objFWMapping: {
        LatestFW: '--',
        PartName: '',
        Part: '--',
        PartType: '--'
      },
      objUpdatedVer: {},
      objPartFWData: {},
      objUpdatedMsg: {
        Status: '',
        Message: '',
        Progess: ''
      },
      loadData: {
        arrFwList: false
      }
    };
  },
  components: {
    UploadModal,
    Loading
  },
  created () {
    this.funcGetBikeLatestFW();
  },
  mounted () {
    // 一進入Update 這頁，先把目前腳踏車的配置紀錄在 localStorage，以便FW更新失敗的處置
    this.funcStoreCurrentBikeDeviceInfo();
  },
  computed: {
    ...mapGetters({
      getBikeId: 'bikeConnect/getBikeId',
      getDeviceInfo: 'bikeConnect/getDeviceInfo',
      getAllBikeInfoList: 'bikeInformation/getAllBikeInfoList'
    }),
    deviceInfo () {
      // 取得firmware 版本值
      return [
        this.getDeviceInfo.ConsolePN,
        this.getDeviceInfo.DisplayPN,
        this.getDeviceInfo.DriverPN
      ];
    },
    systemInfoList () {
      return this.getAllBikeInfoList.bikeSystemInfo ? this.getAllBikeInfoList.bikeSystemInfo.FwList : [];
    },
    fwVerInfoList () {
      // 顯示update list
      const currentArr = this.systemInfoList
        .map(item => Object.assign({}, item))
        .sort((a, b) => (a['Type'] > b['Type']) ? 1 : -1);
      // const currentArr = _.sortBy(this.systemInfoList, [function(o) { return o.Type }])

      let test = Object.assign([], currentArr);
      test.forEach(item => {
        Object.assign(item, this.getLatestFwByType(item, item.Type));
      });
      // console.log('fwVerInfoList =>', test)
      return test;
    },
    loading () {
      return Object.values(this.loadData).includes(false);
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.boolUpdateStart) {
      let confirmAnswer = this.$refs.refWindowEvent.prepareToExit(next);
      return confirmAnswer;
    } else {
      next();
    }
  },
  methods: {
    funcBrowserClose (e) {
      e.preventDefault();
      e.returnValue = '';
    },
    createBeforeunloadHandler () {
      window.addEventListener('beforeunload', this.funcBrowserClose, false);
    },
    destroyedBeforeunloadHandler () {
      window.removeEventListener('beforeunload', this.funcBrowserClose, false);
    },
    getLatestFwByType (currentPartItem, type) {
      const latestArr = this.arrFwList
        .map(item => Object.assign({}, item))
        .sort((a, b) => (a['PartType'] > b['PartType']) ? 1 : -1);

      let obj = {
        LatestFW: '--',
        PartName: '',
        Part: '--',
        PartType: '--'
      };
      latestArr.forEach(item => {
        if (item.PartType === type) {
          // if api return lastest versio is --. Therefore, lastest version is current version.
          if (item.LatestFW === '--') {
            item.LatestFW = currentPartItem.FwVer;
          }
          obj = item;
        }
      });
      return obj;
    },
    funcCheckFWVer (hasData, partType, currentVer, lastVer) {
      // console.log(partType)
      let isUpdate = false;
      // 如 ConsolePN 為 Gorilla 則整車不允許更新
      if (!checkIsGorillaPN(this.getDeviceInfo.ConsolePN)) {
        switch (partType) {
          case 'C':
            isUpdate = this.funcIsCouldUpdatedHY(hasData, currentVer, lastVer);
            break;
          case 'D':
            isUpdate = this.funcIsCouldUpdatedHY(hasData, currentVer, lastVer);
            break;
          case 'M':
            isUpdate = this.funcIsCouldUpdatedBR(hasData, currentVer, lastVer);
            break;
          case 'P':
            isUpdate = this.funcIsCouldUpdatedHY(hasData, currentVer, lastVer);
            break;
          default:
            isUpdate = false;
        }
      }
      return isUpdate;
    },
    funcIsCouldUpdatedBR (hasData, currentVer, lastVer) {
      if (!hasData) return false;
      if (currentVer === '--' && hasData) return true;
      if (currentVer.split(':')[1] < lastVer.split(':')[1]) return true;
      return false;
    },
    funcIsCouldUpdatedHY (hasData, currentVer, lastVer) {
      let currentFirstChar = currentVer.substr(0, 1);
      let lastFirstChar = lastVer.substr(0, 1);
      if (!hasData) return false;
      if (currentFirstChar !== lastFirstChar) return false;
      if (currentVer.substr(1) < lastVer.substr(1)) return true;
      return false;
    },
    funcCloseModal (text) {
      if (text === 'close') {
        this.objUpdatedMsg = {
          Status: '',
          Message: '',
          Progess: ''
        };
        this.boolUpdateStart = false;
        this.destroyedBeforeunloadHandler();
        // console.log('nowUpdatedComponent', this.nowUpdatedComponent.PartType)
        if (this.nowUpdatedComponent.PartType !== 'C' || !this.nowUpdatedComponent.CompletedUpdate) {
          // 如果part type 不是console 或是 更新失敗，就需要keep connect
          this.funcTimeInterval();
        }
        this.nowUpdatedComponent = { PartType: '' };
        // console.log('call keep connect => Update line173')
      }
    },
    funcShowImage (item) {
      // console.log('funcShowImage <=', item)
      switch (item.Type) {
        case 'C':
        {
          let filterPN = funcOriginalPartNo(item.PartNO);
          const allowPart = allowPartNo[filterPN];
          let imageName = '';
          if (allowPart) {
            imageName = allowPart.photo;
          } else {
            imageName = 'no_image.jpg';
          }
          return require(`@/assets/images/diagnosis/${imageName}`);
        }
        case 'D':
          return require('@/assets/images/update/Driver.jpg');
        case 'M':
          return require('@/assets/images/update/Driver_motor.png');
        case 'P':
          return require('@/assets/images/update/LCD_Display.jpg');
      }
    },
    funcOkBtnDialog () {
      if (this.boolDisconnect) {
        this.modalOpenDisconnect = false;
        this.$router.push('/connect');
      } else {
        this.modalOpenDisconnect = false;
      }
    },
    async funcGetBikeLatestFW () {
      // Part No 獲得最新FW的版本資訊
      const encryptData = funcEncryptData({ PartNoList: this.deviceInfo });
      // console.log('funcGetBikeLatestFW data',{PartNoList: this.deviceInfo})
      try {
        const data = await connectBikeAPI.getBikeLatestFW(encryptData)
          .then(res => funcDecryptData(JSON.parse(res)));
          // console.log('funcGetBikeLatestFW',data)
        if (data.ErrorCode === 0) {
          this.arrFwList = data.FwList;
        }

        /**
           * 只要看到Loading 有setimeout是暫時性寫法。
           * 之後會需要麻煩自定義共用組件，可以給時間，自動時間到去執行，
           * 不用每次寫setimeout
           * */
      } catch (e) {
        this.funcOpenErrorDialog();
      }
      setTimeout(() => {
        this.loadData.arrFwList = true;
      }, 1000);
    },
    async funcGetPartFWData (partData) {
      this.updateStatus.count = 0;
      // console.log('partData', partData)
      /**
       * Part No 獲得最新FW的內容
       * 當按Update Btn
       */
      // alert(data)
      // clearInterval(this.timeInterval)
      this.createBeforeunloadHandler();
      this.boolUpdateStart = true;
      this.objUpdatedVer = partData;
      const encryptData = funcEncryptData({ PartNo: partData.PartNO });
      try {
        const data = await connectBikeAPI.getPartFWData(encryptData)
          .then(res => funcDecryptData(JSON.parse(res)));
        if (data.ErrorCode === 0) {
          this.objPartFWData = data;
        } else {
          this.objPartFWData = {};
        }
      } catch (e) {
        this.objPartFWData = {};
      }
      switch (partData.Type) {
        case 'C':
          clearInterval(this.timeInterval);
          // console.log('close keep connect => update c')
          this.ws.UpgradeConsole(this.objPartFWData.FWData, this.objPartFWData.FWChecksum);
          break;
        case 'P':
          clearInterval(this.timeInterval);
          // console.log('close keep connect => update p')
          this.ws.UpgradeDisplay(this.objPartFWData.FWData, this.objPartFWData.FWChecksum);
          break;
        case 'D':
          clearInterval(this.timeInterval);
          // console.log('close keep connect => update d')
          this.ws.UpgradeDriver(this.objPartFWData.FWData, this.objPartFWData.FWChecksum);
          break;
        case 'M':
          clearInterval(this.timeInterval);
          // console.log('close keep connect => update m')
          this.ws.UpgradeBroseDrive(this.objPartFWData.FWData, this.objPartFWData.FWChecksum, this.objPartFWData.FWParametersData, this.objPartFWData.FWParametersChecksum);
          break;
      }
    },
    funcStoreCurrentBikeDeviceInfo () {
      this.$store.dispatch('bikeConnect/storeLocalDeviceInfo', this.getDeviceInfo);
    },
    funcOpenErrorDialog () {
      this.boolDisconnect = true;
      this.hideFooter = false;
      let errorCode = '20012';
      this.errMsgDialog({
        title: this.$t('disconnect.modalTitle'),
        show: true,
        errCode: errorCode,
        btnOk: this.$t('disconnect.modalBtnOk')
      });
    }
  },
  beforeDestroy () {
    // 移除beforeunload事件
    this.destroyedBeforeunloadHandler();
  }
};
</script>
